import { __decorate, __metadata } from "tslib";
import { Expose, Model, ModelId } from '@core/shared/model';
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
let GetNotificationCountResponse = /*#__PURE__*/(() => {
  let GetNotificationCountResponse = class GetNotificationCountResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Number)], GetNotificationCountResponse.prototype, "unread", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], GetNotificationCountResponse.prototype, "total", void 0);
  GetNotificationCountResponse = __decorate([ModelId("GetNotificationCountResponse") // auto-generated by generate-model-ids
  ], GetNotificationCountResponse);
  return GetNotificationCountResponse;
})();
export { GetNotificationCountResponse };
let GetNotificationCountRequest = /*#__PURE__*/(() => {
  let GetNotificationCountRequest = class GetNotificationCountRequest extends Model {
    static {
      this.Response = GetNotificationCountResponse;
    }
  };
  GetNotificationCountRequest = __decorate([AppRequest('notifications', 'get-notification-count', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("GetNotificationCountRequest") // auto-generated by generate-model-ids
  ], GetNotificationCountRequest);
  return GetNotificationCountRequest;
})();
export { GetNotificationCountRequest };